export class HierarchyLookupModel {
	id: number;
    name: string;
    parentId?: number;
}
